export const NAMEKEY = process.env.VUE_APP_NAME_KEY
export const ENDPOINT = process.env.VUE_APP_API_LOCAL
export const URL_FILES = process.env.VUE_APP_FILES_BACKEND + '/files/'